/**
 * Drupal image utilities for event images
 */

const DRUPAL_FILES_SEGMENT = '/sites/default/files/';

function decodeDoubleEncodedUrl(imageUrl: string): string {
  if (!imageUrl || !imageUrl.includes('%25')) {
    return imageUrl;
  }

  // Only decode double-encoded sequences (e.g. %2520 -> %20) to avoid over-decoding.
  return imageUrl.replace(/%25([0-9A-Fa-f]{2})/g, '%$1');
}

export function withDrupalImageStyle(imageUrl: string, style: string): string {
  const normalizedUrl = decodeDoubleEncodedUrl(imageUrl);
  if (!normalizedUrl || !style) {
    return normalizedUrl;
  }

  const [baseUrl, query] = normalizedUrl.split('?');

  if (!baseUrl || !baseUrl.includes(DRUPAL_FILES_SEGMENT)) {
    return normalizedUrl;
  }

  if (baseUrl.includes('/styles/')) {
    return normalizedUrl;
  }

  const [prefix, suffix] = baseUrl.split(DRUPAL_FILES_SEGMENT);
  if (!suffix) {
    return normalizedUrl;
  }

  const styledUrl = `${prefix}${DRUPAL_FILES_SEGMENT}styles/${style}/public/${suffix}`;
  return query ? `${styledUrl}?${query}` : styledUrl;
}
